import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getInventoryGeneral, getInventoryMain } from '../../actions/inventoryActions'
import InventoryListView from '../../containers/Inventory/InventoryGeneral/InventoryListView'
import InventoryListForSaleView from '../../containers/Inventory/InventoryListForSale/InventoryListForSale'

const InventoryListForSale = () => {
  const { products } = useSelector(state => state.inventory)
  const { userInfo } = useSelector(state => state.userInfo)
  const dispatch = useDispatch()
  useEffect(() => {
    let type = "";
    let id = "";
    if (userInfo.representativeID) {
      if (userInfo.representativeID.state ===2) {
        type ="general"
        id = userInfo.representativeID._id
      }
    }
    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state ===2) {
        type ="general"
        id = userInfo.franchiseID._id
      }
    }
    if (userInfo.warehouseID) {
      type ="main"
      id = userInfo.warehouseID
      
    }
    if(type =="general"){
      dispatch(getInventoryGeneral(id))
    }
    if(type ==="main"){
      dispatch(getInventoryMain(id))
    }

    return () => {

    }
  }, [userInfo])

  return (
    <InventoryListForSaleView products={products} />
  )
}

export default InventoryListForSale